import { capitalize } from 'lodash';
import { SentimentName } from 'v2/core/entities/fields';
import {
  OperatorSentimentNegative,
  OperatorSentimentNeutral,
  OperatorSentimentPositive,
} from 'v2/core/services/queryBuilder/operators';

export const getOperatorSentimentFromString = (sentiment?: string) => {
  switch (capitalize(sentiment)) {
    case SentimentName.POSITIVE:
      return OperatorSentimentPositive;
    case SentimentName.NEUTRAL:
      return OperatorSentimentNeutral;
    case SentimentName.NEGATIVE:
      return OperatorSentimentNegative;
  }

  return OperatorSentimentNeutral;
};
